import { Box, Text } from "@hightouch/htui";

export const EntityCardNoPreview = () => (
  <Box
    width="100%"
    sx={{ aspectRatio: "1 / 1" }}
    bg="base.border"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Text color="text.tertiary" size="sm">
      No preview
    </Text>
  </Box>
);
